import { render, staticRenderFns } from "./SmplEditCombinationChild.vue?vue&type=template&id=fab55af4&"
import script from "./SmplEditCombinationChild.vue?vue&type=script&lang=js&"
export * from "./SmplEditCombinationChild.vue?vue&type=script&lang=js&"
import style0 from "./SmplEditCombinationChild.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports